import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=956ce9f4"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_css-loader@6.11.0_webpack@5.106.2__ejs@3.1._9f3d0d3104055eba53a1ff77b8bed3ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports